module.exports = __webpack_public_path__ + "img/main.76581572.png";